import React, { useContext } from 'react';
import { ReportingContainerBaseConfig } from '../../../base';
import { ContentDetailContainerProps } from './contentDetailProps';
import { ContentDetailLoader } from './contentDetailInterface';
import { z } from 'zod';
import { DocumentEditorContainerProps } from '../../document';

export function createContentDetailContainer(
    config: ReportingContainerBaseConfig & {
        Container: {
            Report: React.FC;
            Chapter: React.FC;
            Document: React.FC;
        };
    },
    loader: ContentDetailLoader
): React.FC<ContentDetailContainerProps> {
    const {
        context: { useContext },
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        Container: {
            Report: ReportContainer,
            Chapter: ChapterContainer,
            Document: DocumentContainer,
        },
    } = config;

    const UrlParamsSchema = z.object({
        contentId: z.string(),
        raw: z.boolean({ coerce: true }).optional(),
    });

    return ({ ...containerProps }) => {
        const params = useOptions(UrlParamsSchema);
        const context = useContext();
        const data = loader.useLoad(context, {
            id: params.contentId,
        });
        if (data.content.type === 'report' && !params.raw) {
            return <ReportContainer />;
        }
        if (data.parent?.type === 'report' && !params.raw) {
            return <ChapterContainer />;
        }
        return <DocumentContainer />;
    };
}
